import PropTypes from 'prop-types';

export const STAT_CARD_BASE =
  'rounded-2xl bg-white dark:bg-neutral-900 ring-1 ring-neutral-200/70 dark:ring-neutral-800 shadow-[0_1px_2px_rgba(16,24,40,0.04),0_8px_24px_-12px_rgba(16,24,40,0.08)]';

export const STAT_CHIP = {
  blue:    'bg-blue-50 text-blue-600 ring-1 ring-inset ring-blue-100 dark:bg-blue-500/10 dark:text-blue-400 dark:ring-blue-500/20',
  violet:  'bg-violet-50 text-violet-600 ring-1 ring-inset ring-violet-100 dark:bg-violet-500/10 dark:text-violet-400 dark:ring-violet-500/20',
  emerald: 'bg-emerald-50 text-emerald-600 ring-1 ring-inset ring-emerald-100 dark:bg-emerald-500/10 dark:text-emerald-400 dark:ring-emerald-500/20',
  amber:   'bg-amber-50 text-amber-600 ring-1 ring-inset ring-amber-100 dark:bg-amber-500/10 dark:text-amber-400 dark:ring-amber-500/20',
  rose:    'bg-rose-50 text-rose-600 ring-1 ring-inset ring-rose-100 dark:bg-rose-500/10 dark:text-rose-400 dark:ring-rose-500/20',
  indigo:  'bg-indigo-50 text-indigo-600 ring-1 ring-inset ring-indigo-100 dark:bg-indigo-500/10 dark:text-indigo-400 dark:ring-indigo-500/20',
  purple:  'bg-purple-50 text-purple-600 ring-1 ring-inset ring-purple-100 dark:bg-purple-500/10 dark:text-purple-400 dark:ring-purple-500/20',
  primary: 'bg-primary-50 text-primary-600 ring-1 ring-inset ring-primary-100 dark:bg-primary-500/10 dark:text-primary-400 dark:ring-primary-500/20',
  green:   'bg-green-50 text-green-600 ring-1 ring-inset ring-green-100 dark:bg-green-500/10 dark:text-green-400 dark:ring-green-500/20',
  red:     'bg-red-50 text-red-600 ring-1 ring-inset ring-red-100 dark:bg-red-500/10 dark:text-red-400 dark:ring-red-500/20',
  teal:    'bg-teal-50 text-teal-600 ring-1 ring-inset ring-teal-100 dark:bg-teal-500/10 dark:text-teal-400 dark:ring-teal-500/20',
  slate:   'bg-slate-100 text-slate-600 ring-1 ring-inset ring-slate-200 dark:bg-slate-500/10 dark:text-slate-400 dark:ring-slate-500/20',
};

const StatCard = ({
  label,
  value,
  icon: Icon,
  variant = 'blue',
  onClick,
  active = false,
  className = '',
}) => {
  const interactive = typeof onClick === 'function';
  const Tag = interactive ? 'button' : 'div';
  const activeRing = active ? 'ring-2 ring-primary-500 dark:ring-primary-400' : '';

  return (
    <Tag
      type={interactive ? 'button' : undefined}
      onClick={onClick}
      className={`${STAT_CARD_BASE} p-5 text-left ${interactive ? 'cursor-pointer transition-colors' : ''} ${interactive && !active ? 'hover:ring-neutral-300 dark:hover:ring-neutral-700' : ''} ${activeRing} ${className}`}
    >
      <div className="flex items-center gap-2.5 mb-3">
        {Icon && (
          <span className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${STAT_CHIP[variant] || STAT_CHIP.blue}`}>
            <Icon size={20} strokeWidth={1.75} />
          </span>
        )}
        <span className="text-sm font-medium text-neutral-500 dark:text-neutral-400 truncate">{label}</span>
      </div>
      <span className="block text-3xl font-semibold tabular-nums tracking-tight leading-none text-neutral-900 dark:text-neutral-50">
        {value}
      </span>
    </Tag>
  );
};

StatCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  icon: PropTypes.elementType,
  variant: PropTypes.oneOf([
    'blue', 'violet', 'emerald', 'amber', 'rose', 'indigo',
    'purple', 'primary', 'green', 'red', 'teal', 'slate',
  ]),
  onClick: PropTypes.func,
  active: PropTypes.bool,
  className: PropTypes.string,
};

export default StatCard;
